module.exports = __webpack_public_path__ + "img/signup.e21c5f1e.jpg";